<template>
  <div :class="bemBlockMod('scroll-down-animation')">
    <div :class="bemElement('filter-container')">
      <TheProductListColumnMode />
      <button
        :class="[bemElement('filters-button'), 'btn']"
        @click="openFilters"
      >
        {{
          $msg('filters.quantity.text', 'filters', [appliedFiltersTextQuantity])
        }}
      </button>
    </div>
    <TheProductListSiblingMenu
      v-if="siblingMenu.length > 0"
      :class="bemElement('sibling-menu')"
      :sibling-menu="siblingMenu"
      :current-category="currentCategory"
      :is-view-all-view="isViewAllView"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getters } from '../store';
import bemClassesMixin from '../mixins/bemClassesMixin';
import TheProductListColumnMode from './TheProductListColumnMode.vue';
import TheProductListSiblingMenu from './TheProductListSiblingMenu.vue';

export default {
  name: 'TheProductListHeader',

  components: {
    TheProductListColumnMode,
    TheProductListSiblingMenu,
  },

  mixins: [bemClassesMixin],

  props: {
    siblingMenu: {
      type: Array,
      default() {
        return [];
      },
    },
    currentCategory: {
      type: Object,
      default: null,
    },
    isViewAllView: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters({
      uiNumAppliedFilters: getters.productList.uiNumAppliedFilters,
    }),
    appliedFiltersTextQuantity() {
      return this.uiNumAppliedFilters > 0 ? this.uiNumAppliedFilters : '+';
    },
  },

  methods: {
    openFilters() {
      this.$eventBus.$emit('the-product-list:open-filters');
    },
  },
};
</script>
